<template>
	<VerticalLayout>
		<TypographyTitle :level="3" class="pd-lg-x pd-md-top" :aria-label="$t(titleKey)">{{ $t(titleKey) }}</TypographyTitle>
		<TimeSeriesChart :isLoading="isLoading" :series="series" :options="chartOptions" :height="400" />
	</VerticalLayout>
</template>

<script>
import { computed } from 'vue';
import { TypographyTitle } from 'ant-design-vue';
import { useI18n } from 'vue-i18n';

import { getBaseOptions, generateSeries, setXAxisRange, nullSafeFormatter, makeSubNetworkParamSeriesKey } from '@/utils/chartsUtils';

import VerticalLayout from '@/components/common/VerticalLayout';
import TimeSeriesChart from '@/components/stats/TimeSeriesChart';


const getMountpointLabel = (mountpoint, t) => {
	if (mountpoint.endsWith('_total')) {
		return t('stats.convergence.total');
	}
	if (mountpoint.endsWith('_isln')) {
		return t('stats.convergence.isln');
	}
	return mountpoint;
};

const getValue = item => item.final_value;

export default {
	components: {
		TypographyTitle,
		VerticalLayout,
		TimeSeriesChart,
	},
	props: {
		titleKey: {
			type: String,
			required: true,
		},
		mountpoints: {
			type: Array,
			required: true,
		},
		apiData: {
			type: Object,
			required: true,
		},
		isLoading: {
			type: Boolean,
			required: true,
		},
		datesRangeSafe: {
			type: Array,
			required: true,
		},
		subNetworks: {
			type: Array,
			required: true,
		},
	},
	setup(props) {
		const { t } = useI18n();

		const series = computed(() => generateSeries({
			items: props.apiData.statsItems.filter(
				item => item.kind === 'convergenceCounts' && props.mountpoints.includes(item.mountpoint),
			),
			getSeriesKeyFn: makeSubNetworkParamSeriesKey({
				subNetworks: props.subNetworks,
				period: props.apiData.period,
				getParamFn: item => getMountpointLabel(item.mountpoint, t),
			}),
			getValueFn: getValue,
			seriesStep: props.apiData.period,
		}).series);

		const chartOptions = computed(() => {
			let options = getBaseOptions('convergenceCounts', series.value, props.apiData.funcCount);
			options.yaxis.title.text = '';
			options.yaxis.min = 0;
			options.yaxis.decimalsInFloat = 0;
			options.yaxis.forceNiceScale = true;
			setXAxisRange(options, props.datesRangeSafe);
			options.tooltip.y.formatter = nullSafeFormatter(value => String(Math.round(value)));
			return options;
		});

		return {
			series,
			chartOptions,
		};
	},
};
</script>
